import { render, staticRenderFns } from "./WeekRegistrations.vue?vue&type=template&id=df9f9c5c&"
import script from "./WeekRegistrations.vue?vue&type=script&lang=js&"
export * from "./WeekRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WeekRegistrations.vue"
export default component.exports